import { persistReducer, persistStore, createTransform } from 'redux-persist';
import { configureStore } from '@reduxjs/toolkit';
import logger from 'redux-logger';
import ExamineStorage from './localStorage';

// 自定義 storage engine，使用我們的 ExamineStorage
const customStorage = {
    getItem: (key) => {
        return new Promise((resolve) => {
            const value = ExamineStorage.getItem(key);
            resolve(value);
        });
    },
    setItem: (key, value) => {
        return new Promise((resolve) => {
            ExamineStorage.setItem(key, value);
            resolve();
        });
    },
    removeItem: (key) => {
        return new Promise((resolve) => {
            ExamineStorage.removeItem(key);
            resolve();
        });
    }
};

// Redux Persist 設定
// Transform 函數：移除 tab content 中的 React 元素
const tabTransform = createTransform(
    // inbound: 持久化前的轉換
    (inboundState) => {
        if (inboundState && inboundState.tabList) {
            return {
                ...inboundState,
                tabList: inboundState.tabList.map(tab => ({
                    ...tab,
                    content: null // 不持久化 React 元素
                }))
            };
        }
        return inboundState;
    },
    // outbound: 從持久化狀態恢復時的轉換
    (outboundState) => {
        // 從持久化狀態恢復時，content 會在渲染時重新建立
        return outboundState;
    },
    // 指定要轉換的 reducer
    { whitelist: ['app'] }
);

export const persistConfig = {
    key: 'root', // 透過 ExamineStorage 使用 Examine_ 前綴
    storage: customStorage,
    whitelist: ['app'], // 只持久化 app reducer
    blacklist: [], // 不持久化的 reducer
    transforms: [tabTransform], // 資料轉換器，移除不可序列化的內容
    debug: process.env.NODE_ENV === 'development', // 開發模式下啟用 debug
    throttle: 1000, // 節流，避免頻繁寫入
};

// 創建 store 的工廠函數
export const createPersistedStore = (rootReducer) => {
    // 包裝 rootReducer 使其支援 persist
    const persistedReducer = persistReducer(persistConfig, rootReducer);

    // 創建 store
    const store = configureStore({
        reducer: persistedReducer,
        middleware: (getDefaultMiddleware) =>
            getDefaultMiddleware({
                serializableCheck: {
                    ignoredActions: [
                        'persist/PERSIST',
                        'persist/REHYDRATE',
                        'persist/PAUSE',
                        'persist/PURGE',
                        'persist/REGISTER',
                        'TAB_ADD' // 保留原有的忽略設定
                    ],
                },
            }).concat(logger), // logger 放在最後
    });

    // 創建 persistor
    const persistor = persistStore(store);

    return { store, persistor };
};

// 工具函數
export const clearPersistedState = () => {
    ExamineStorage.clear();
};

export const getPersistedKeys = () => {
    return ExamineStorage.getProjectKeys();
};

export const getStorageSize = () => {
    return ExamineStorage.getSize();
};